module.exports = __webpack_public_path__ + "static/media/pedro-lastra.2df395cb.jpg";